
















// 3rd party libs
import Vue from 'vue';
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Config
import socios from '@webapp/socios.json';

// Shared modules
import {
    JumioSubmissionResult,
} from '@shared/types/api/kyc';
import type {
    FetchJumioWebClientUrlParams,
} from '@shared/store/modules/jumio';

// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';

const JUMIO_IFRAME_MOBILE_SIZE = {
    width: '100%',
    height: 550,
};
const JUMIO_IFRAME_SIZES = [
    {
        width: 900,
        height: 710,
    },
    {
        width: 640,
        height: 660,
    },
    {
        width: 560,
        height: 600,
    },
    {
        width: 480,
        height: 535,
    },
];

export default Vue.extend({
    components: {
        loadingSpinner,
    },
    props: {
        documentType: {
            type: String,
            required: true,
        },
        country: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            iframeSize: {
                width: '100%',
                height: 600,
            },
            isIframeSizeAlreadySet: false,
        };
    },
    computed: {
        ...mapGetters([
            'userId',
            'kycValidationRequestAttempt',
            'locale',
            'isMobileDevice',
        ]),

        ...mapGetters('jumio', ['webClientUrl', 'externalRequestId']),
    },
    watch: {
        webClientUrl(url: string) {
            if (url) {
                this.isLoading = false;
            }
        },
    },
    created() {
        this.initializeJumioProcess();
        window.addEventListener('message', this.onJumioSubmission);
    },
    destroyed() {
        window.removeEventListener('message', this.onJumioSubmission);
    },
    methods: {
        ...mapActions({
            startKycValidationRequest: 'startKycValidationRequest',
        }),

        ...mapActions('jumio', ['fetchJumioWebClientUrl']),

        async initializeJumioProcess() {
            const payload = {
                userId: this.userId,
                locale: this.locale,
                workflow: 'web',
                country: this.country,
                documentType: this.documentType,
                successUrl: `${socios.paymentGatewayUrl}/jumio-result?success=true`,
                errorUrl: `${socios.paymentGatewayUrl}/jumio-result?success=false`,
                callbackUrl: this.kycValidationRequestAttempt.callbackUrl,
            } as FetchJumioWebClientUrlParams;

            await this.fetchJumioWebClientUrl(payload);
        },

        onJumioSubmission({ data }: { data: JumioSubmissionResult }) {
            if (data?.type !== 'jumioResult') {
                return;
            }

            this.$emit(data.success ? 'success' : 'error', this.externalRequestId);
        },

        setIframeSize() {
            if (this.isMobileDevice) {
                this.iframeSize = JUMIO_IFRAME_MOBILE_SIZE;
                this.isIframeSizeAlreadySet = true;

                return;
            }

            const iframeWrapperWidth = this.$refs.jumioIframeWrapper?.clientWidth || 650;

            this.iframeSize = JUMIO_IFRAME_SIZES.find((size) => size.width <= iframeWrapperWidth) ||
                JUMIO_IFRAME_SIZES[3];
            this.isIframeSizeAlreadySet = true;
        },
    },
});
